import React from 'react';
import HomePage from '../components/Views/HomePage';
import Layout from '../components/Layout/Layout';
import { getSeoData } from '../utils/helpers';
import initApollo from '../utils/init-Apollo';
import { getInitialItems, getCombinedHomePageData } from '../api/queries';
import { REVALIDATE_SECONDS, ITEMS_LIMIT } from '../utils/constants/homePage';
import { extractApolloState } from '../utils/helpers/extractApolloState';
import { loadHomePageMockData } from '../utils/helpers/getHomePageMockData';
import { withBugsnagGetStaticProps } from '../utils/withBugsnag';

const App = props => <HomePage {...props} />;

const isE2E = process.env.NEXT_PUBLIC_E2E === '1';

export const getStaticProps = withBugsnagGetStaticProps(
  async ({ locale }) => {
    const apolloClient = initApollo({}, { lang: locale });

    if (isE2E && process.env.NODE_ENV !== 'production') {
      try {
        await loadHomePageMockData(apolloClient);

        return extractApolloState(apolloClient, {
          props: {
            seoData: null,
            currentLang: locale
          },
          revalidate: REVALIDATE_SECONDS
        });
      } catch (error) {
        console.error('Error loading mock data:', error);
      }
    }

    const [seoData] = await Promise.all([
      getSeoData(apolloClient),
      apolloClient.query({ query: getCombinedHomePageData }),
      apolloClient.query({
        query: getInitialItems,
        variables: {
          limit: ITEMS_LIMIT,
          offset: 0
        }
      })
    ]);

    return extractApolloState(apolloClient, {
      props: {
        seoData,
        currentLang: locale
      },
      revalidate: REVALIDATE_SECONDS
    });
  },
  'index',
  {
    seoData: null,
    apolloState: {},
    currentLang: 'az',
    error: true
  }
);

App.getLayout = (page, pageProps) => (
  <Layout pageProps={pageProps} isHomePage isBanner isBackgroundBanner>
    {page}
  </Layout>
);

export default App;
